import React from 'react';
import { Loader2 } from 'lucide-react';

const TaraButton = ({ 
  variant = 'primary', 
  size = 'lg', 
  loading = false,
  icon,
  children,
  className = '',
  ...props 
}) => {
  const variants = {
    primary: 'bg-gradient-to-r from-cosmic-500 to-cosmic-600 text-white hover:from-cosmic-600 hover:to-cosmic-700 shadow-card hover:shadow-card-hover active:scale-[0.98]',
    sacred: 'bg-gradient-to-r from-sacred-400 to-sacred-500 text-stone-900 hover:from-sacred-500 hover:to-sacred-600 shadow-sacred',
    secondary: 'bg-stone-100 text-stone-900 hover:bg-stone-200 border border-stone-200',
    ghost: 'bg-transparent text-stone-700 hover:bg-stone-100',
  }
  
  const sizes = {
    sm: 'px-4 py-2 text-sm rounded-button',
    md: 'px-6 py-3 text-base rounded-button',
    lg: 'px-8 py-4 text-lg rounded-button',
  }
  
  return (
    <button
      className={`
        ${variants[variant]} 
        ${sizes[size]}
        ${className}
        font-medium transition-all duration-200 
        disabled:opacity-50 disabled:cursor-not-allowed
        flex items-center justify-center gap-2
      `}
      disabled={loading}
      {...props}
    >
      {loading && <Loader2 className="w-5 h-5 animate-spin" />}
      {!loading && icon && <span>{icon}</span>}
      {children}
    </button>
  )
}

export default TaraButton;